import script from "./SettingsBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsBox.vue?vue&type=script&setup=true&lang=js"

import "./SettingsBox.vue?vue&type=style&index=0&id=7483c948&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7483c948"]])

export default __exports__